<template>
  <!--
      作者：zhuchangtao
      时间：2021-01-18
      描述：配送-拣货列表-拣货
  -->
  <el-dialog title="拣货" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
    :close-on-press-escape="false">
    <el-tabs v-model="activeName">

      <el-tab-pane label="完成拣货" name="first">
        <el-form size="small" :model="orderform">

          <el-form-item label="件数" :label-width="formLabelWidth" :rules="[{ required: true, message: '请填写件数' }]" prop="picking_number">
            <el-input v-model="orderform.picking_number" placeholder="请输入件数" :minLength="1"></el-input>
          </el-form-item>
          <el-form-item label="体积" :label-width="formLabelWidth" :rules="[{ required: true, message: '请填写体积' }]" prop="picking_volume">
            <el-input type="textarea" v-model="orderform.picking_volume" placeholder="请输入体积"></el-input>
          </el-form-item>
        </el-form>
      </el-tab-pane>

    </el-tabs>


    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="addUser(form.order_id)" :loading="loading">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import DistributionApi from '@/api/distribution.js';
  export default {
    data() {
      return {
        loading: false,
        /*左边长度*/
        formLabelWidth: '120px',
        /*是否显示*/
        dialogVisible: false,
        /*默认选中*/
        activeName: 'first',
        orderform:{
          picking_number:'',
          picking_volume:'',
        }



      };
    },
    props: ['open_add', 'form'],
    created() {
      this.dialogVisible = this.open_add;
    },
    methods: {


      /*充值*/
      addUser(e) {
        let self = this;
        let params = self.orderform;
        let order_id = e;
        if(params.picking_number <=0 || params.picking_number == ''){

          self.$message.error('件数不能为空');
          self.loading = false;
        }
        if(params.picking_volume == ''){

          self.$message.error('体积不能为空');
          self.loading = false;
        }
        if(params.picking_number != '' && params.picking_volume != '' && params.picking_number >0){
          self.loading = true;
          DistributionApi.pickingOrderAdd({
              picking_number: params.picking_number,
              picking_volume: params.picking_volume,
              order_id: order_id,
          
            }, true).then(data => {
              self.loading = false;
              if (data.code == 1) {
                self.$message({
                  message: '恭喜你，修改成功',
                  type: 'success'
                });
                self.dialogFormVisible(true);
              } else {
                self.loading = false;
                self.$message.error('错了哦，这是一条错误消息');
              }
            })
            .catch(error => {
              self.loading = false;
            });
        }
        


      },

      /*关闭弹窗*/
      dialogFormVisible(e) {
        if (e) {
          this.$emit('closeDialog', {
            type: 'success',
            openDialog: false
          })
        } else {
          this.$emit('closeDialog', {
            type: 'error',
            openDialog: false
          })
        }
      }

    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/distribution/order/dialog/Add.vue